exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-item-column .input-switcher[data-v-0451cbaf] {\n  position: absolute;\n  left: 20px;\n  font-size: 12px;\n  color: var(--primary-color);\n  cursor: pointer;\n}\n", ""]);

// exports
